<template>
  <div class="product-card-container">
    <div class="card-container">
      <div v-for="(item, i) in products" :key="i" class="wow fadeInUp card">
        <img
          v-if="item.profile && item.profile.length > 0"
          :src="getImage(item.profile)"
          alt="product"
        />
        <div class="image-overlay"></div>
        <h3>{{ item.title[getIndex()] }}</h3>
        <router-link :to="'/product/' + item.id">
          {{ $t("seeProject") }}
        </router-link>
      </div>
      <div v-if="showAllProductLink" class="wow rollIn see-all-projects-link">
        <router-link to="/products">
          {{ $t("allProducts") }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectCard",
  props: {
    products: {
      type: Array,
      default: () => []
    },
    showAllProductLink: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getIndex() {
      if (this.$i18n.locale === "ku") return 0;
      else if (this.$i18n.locale === "ar") return 1;
      else return 2;
    },
    getImage(name) {
      return require("../../assets/products/" + name);
    }
  }
};
</script>

<style lang="scss" scoped>
.product-card-container {
  width: 65%;
  margin: auto;
  position: relative;
  z-index: 2;
}
.card-container {
  margin: auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.card {
  width: 30%;
  height: 360px;
  background-color: #cedb2d;
  margin-bottom: 100px;
  text-align: center;
  overflow: hidden;
  position: relative;
}
.card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #282828;
  opacity: 0.6;
  z-index: 1;
}
.card h3 {
  position: absolute;
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.3s;
  padding: 12px 14px;
  z-index: 2;
  color: #fefde5;
}
.card a {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  transition: all 0.3s;
  padding: 12px 14px;
  z-index: 2;
  color: #cedb2d;
  border: 1px solid #cedb2d;
  border-radius: 25px;
}

.card a:hover,
.see-all-projects-link a:hover {
  color: #282828;
  background-color: #cedb2d;
}

.see-all-projects-link {
  margin: auto;
  margin-bottom: 100px;
}

.see-all-projects-link a {
  font-weight: bold;
  transition: all 0.3s;
  padding: 12px 14px;
  z-index: 2;
  color: #cedb2d;
  border: 1px solid #cedb2d;
  border-radius: 25px;
}

@media (max-width: 968px) {
  .product-card-container {
    width: 75%;
  }
  .card {
    width: 45%;
  }
  .card h2 {
    font-size: 20px;
  }
  .card img {
    margin-bottom: 25px;
  }
}

@media (max-width: 768px) {
  .card {
    width: 100%;
    margin-bottom: 50px;
  }
}

@media (max-width: 625px) {
  .product-card-container {
    width: 85%;
  }
}
</style>
